// Extracted from Crm/Invoice.js so the blob-download flow (GET .../invoice/download with
// the session token header, Content-Disposition-derived filename, synthetic <a download>
// click) has one implementation shared by both the CRM-embedded Invoice panel and the
// dedicated Invoices page (see pages/Dashboard/Invoices/InvoicesSection.js). Behavior is
// unchanged from the original: a 401 forces a hard redirect to /login and resolves quietly
// (no throw) so callers that fire-and-forget this don't need their own 401 handling; any
// other error is rethrown so a caller that awaits it (e.g. to show a toast) can react to it.
import axios from 'axios';
import CONSTANTS from '../constants/envConstants';
import {getCurrentToken} from './cookies';

export const downloadInvoiceFile = async (path) => {
    try {
        const token = await getCurrentToken();
        const response = await axios({
            url: `${CONSTANTS.BASE_API_URL}invoice/download`,
            method: 'GET',
            headers: {'Content-Type': 'application/json', 'X-Session-Token': token},
            params: {file_path: encodeURIComponent(path)},
            responseType: 'blob'
        });

        const contentDisposition = response.headers['content-disposition'];
        let filename = path.split('/').pop();
        if (contentDisposition) {
            const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
            if (match?.[1]) filename = match[1].replace(/['"]/g, '');
        }

        const blob = new Blob([response.data], {type: response.headers['content-type']});
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.setAttribute('download', filename);
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    } catch (error) {
        const status = error.response?.status;
        if (status === 401) {
            window.location.href = '/login';
            return;
        }
        throw error;
    }
};
